import * as Sentry from '@sentry/react'

export function initSentry() {
  const enabled = import.meta.env.VITE_SENTRY_ENABLED !== 'false'
  const dsn = import.meta.env.VITE_SENTRY_DSN

  if (!enabled) {
    console.warn('[Sentry] VITE_SENTRY_ENABLED is false. Sentry is disabled.')
    return
  }

  if (!dsn) {
    console.warn('[Sentry] VITE_SENTRY_DSN is not set. Sentry is disabled.')
    return
  }

  Sentry.init({
    dsn,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing — 100% in dev, 10% in production
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api-prod\.easydoochat\.com/,
      /^https:\/\/api-staging\.easydoochat\.com/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Send logs to Sentry
    enableLogs: true,
  })
}
